angular.module("ticketco/ticketbuyer/contact_organizer", [
  "ticketco/ticketbuyer/common",
]);
